var render = function render(_c,_vm){return _c('v-card',{staticClass:"mb-4",attrs:{"outlined":"","md":"12","elevation":"2"}},[_c('v-card-title',[_vm._v("404 Not Found")]),_c('v-divider'),_c('v-card-text')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }